import React, { useState } from "react";
import Snackbar from "../../../../../components/snackbar/snackbar";
import CheckBox from "../../../../../components/inputs/checkbox";
import CustomButton from "../../../../../components/inputs/button";
import TextField from "../../../../../components/inputs/textfield";
import { user_deactivate } from "../../../user.api";

const DeactivatedInfo = (props) => {
  const [answer, setAnswer] = useState("");
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    setFormData({ ...formData, [name]: value });
  };
 
  console.log(props?.appData);
  return (
    <React.Fragment>
      {props.open && (
        <React.Fragment>
          <div className="overlay">
            <div className="deactivatePopup">
              <div className="d-flex flex-column">
                <div className="">
                  <div className="flexDisplay">
                    <div className="diaTitleCon text-danger text-center" >Account Suspended</div>
                    {/* <div
                      className="dia-close"
                      onClick={() => props.handleOpen(false)}
                    >
                      <div className="diaCloseCon text-center">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div> */}
                  </div>

                  <div className="tilebars justify-content-center">
                    <hr />
                  </div>
                </div>
               
                  <div className="row book-form">
                    <div className="">
                      Your account has been suspended! Please contact KSPACE to reactivate your account.
                    </div>

                    <div className="col-12 pt-2">
                      <CustomButton
                        label="Close"
                        onClick={() => props.handleOpen(false)}
                      />
                    </div>
                  </div>
                
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default DeactivatedInfo;
